import { Form, field, required } from "lib/form";

export interface NewsFormSource {
  title: string;
  source?: string;
  imageUrl?: string;
  originalUrl: string;
  publishedDate?: string;
  summary?: string;
  isChecked?: boolean;
  isDismissed?: boolean;
  isDismissedByAi?: boolean;
  sourceImageUrl: string;
  tags?: number[];
  tagsByAi?: number[];
  content?: string;
}

export default class NewsForm extends Form {
  @field("Original URL")
  @required()
  public originalUrl: string;

  @field("Title")
  @required()
  public title: string;

  @field("Published Date")
  // @required()
  public publishedDate: string;

  @field("Image URL") public imageUrl: string;

  @field("Source") public source: string;

  @field("Source Image URL") public sourceImageUrl: string;

  @field("Summary") public summary: string;

  @field("Tags") public tags: number[] = [];

  @field("Tags by AI") public tagsByAi: number[] = [];

  @field("Checked") public isChecked: boolean | undefined;

  @field("Dismissed") public isDismissed: boolean | undefined;

  @field("Dismissed By AI") public isDismissedByAi: boolean | undefined;

  @field("Content") public content: string;
}
